"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTextFromReactChildren = exports.getColorFormString = exports.toCSS = exports.getStyledComponentMainStyles = exports.validateDateFormat = void 0;
var react_1 = require("react");
var theme_1 = __importDefault(require("../../theme"));
/**
 * Validates if the provided date follows the
 * --- <short weekday>, <numeric day> <short month>. <numeric year> --- format.
 * @param date - String representation of the date that wants to be verified.
 * @returns True if the provided date is on format, false otherwise.
 */
function validateDateFormat(date) {
    var validationRegex = /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/i;
    return !!(date && validationRegex.test(date));
}
exports.validateDateFormat = validateDateFormat;
/**
 * Gets the main styles for a styled component, based on the provided type.
 * @param type - A styled component type.
 * @returns The background color and content color to be passed to the styled component.
 */
function getStyledComponentMainStyles(type) {
    switch (type) {
        case "primary":
            return {
                backgroundColor: theme_1.default.colorsPalette.blue.lighter,
                color: theme_1.default.colorsPalette.blue.default,
            };
        case "secondary":
            return {
                backgroundColor: theme_1.default.colorsPalette.gray.lighter,
                color: theme_1.default.colorsPalette.gray.default,
            };
        case "danger":
            return {
                backgroundColor: theme_1.default.colorsPalette.red.lighter,
                color: theme_1.default.colorsPalette.red.default,
            };
        case "success":
            return {
                backgroundColor: theme_1.default.colorsPalette.green.lighter,
                color: theme_1.default.colorsPalette.green.default,
            };
        case "warning":
            return {
                backgroundColor: theme_1.default.colorsPalette.yellow.lighter,
                color: theme_1.default.colorsPalette.yellow.default,
            };
        default:
            return {
                backgroundColor: theme_1.default.colorsPalette.blue.lighter,
                color: theme_1.default.colorsPalette.blue.default,
            };
    }
}
exports.getStyledComponentMainStyles = getStyledComponentMainStyles;
/**
 * Parses an CSS-styles object into a CSS template literal.
 * @param styledObject - CSS props in JSON format (keys in camelCase).
 */
function toCSS(stylesObject) {
    function createParser(matcher, replacer) {
        var regex = RegExp(matcher, "g");
        return function (string) {
            if (!string.match(regex)) {
                return string;
            }
            return string.replace(regex, replacer);
        };
    }
    var kebabize = createParser(/[A-Z]/, function (match) { return "-".concat(match.toLowerCase()); });
    var lines = Object.keys(stylesObject).map(function (property) {
        return "".concat(kebabize(property), ": ").concat(stylesObject[property], ";");
    });
    return lines.join("\n");
}
exports.toCSS = toCSS;
/**
 * Gets an hex color based on a provided string.
 * @param _string - The string to process.
 * @returns - An hexadecimal color string.
 */
function getColorFormString(_string) {
    var hash = 0;
    var i;
    /* eslint-disable no-bitwise */
    for (i = 0; i < _string.length; i += 1) {
        hash = _string.charCodeAt(i) + ((hash << 5) - hash);
    }
    var color = "#";
    for (i = 0; i < 3; i += 1) {
        var value = (hash >> (i * 8)) & 0xff;
        color += "00".concat(value.toString(16)).substr(-2);
    }
    /* eslint-enable no-bitwise */
    return color;
}
exports.getColorFormString = getColorFormString;
/**
 * Gets the string nested into the react node (if it is)
 * @param children - React node to process.
 * @returns - The plane string nested into the react node.
 */
function getTextFromReactChildren(children) {
    var text = "";
    react_1.Children.map(children, function (child) {
        if (typeof child === "string") {
            text += child;
        }
    });
    return text;
}
exports.getTextFromReactChildren = getTextFromReactChildren;
//# sourceMappingURL=index.js.map